import { Box, Chip } from "@mui/material";
import { colors } from "../../../theme/palette";
import typography from "../../../theme/typography";
import { useTranslation } from "react-i18next";

type TypographyStyle = {
  fontFamily: string;
  fontSize: string;
  fontWeight: number;
  lineHeight: string;
  color?: string;
};

const ChatFilterTabs = ({
  isUnreadActive,
  setIsUnreadActive,
}: {
  isUnreadActive: boolean;
  setIsUnreadActive: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation();

  const currentTypography = (active: boolean): TypographyStyle => {
    const fontStyle = active ? typography.body14SemiBold : typography.body14Regular;
    return { ...fontStyle, color: active ? colors.green100 : colors.dark600 };
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: "17px",
        padding: "0 15px 8px",
        borderBottom: "1px solid #EAECF0",
      }}
    >
      <Chip
        label={t("pages.chat.all")}
        onClick={() => setIsUnreadActive(false)}
        sx={{
          padding: "4px 10px",
          borderRadius: "50px",
          minWidth: "50px",
          background: colors.Gray25,
          "& .MuiChip-label": {
            ...currentTypography(!isUnreadActive),
          },
        }}
      />
      <Chip
        label={t("pages.chat.unread")}
        onClick={() => setIsUnreadActive(true)}
        sx={{
          padding: "4px 10px",
          borderRadius: "50px",
          minWidth: "50px",
          background: colors.Gray25,
          "& .MuiChip-label": {
            ...currentTypography(isUnreadActive),
          },
        }}
      />
    </Box>
  );
};

export default ChatFilterTabs;
